export const UPDATE_PROPERTY = 'DETAILED_TRANSACTIONS_HISTORY:UPDATE_PROPERTY';
export const FETCH_FAIL = 'DETAILED_TRANSACTIONS_HISTORY:FETCH_FAIL';
export const UPDATE_SUMMARY_DATA = 'DETAILED_TRANSACTIONS_HISTORY:SUMMARY_DATA:UPDATE';
export const UPDATE_HISTORY_DATA = 'DETAILED_TRANSACTIONS_HISTORY:HISTORY_DATA:UPDATE';
export const CHANGE_FILTER = 'DETAILED_TRANSACTIONS_HISTORY:FILTER:CHANGE';
export const CHANGE_PERIOD = 'DETAILED_TRANSACTIONS_HISTORY:PERIOD:CHANGE';
export const APPLY_ANOTHER_PERIOD = 'DETAILED_TRANSACTIONS_HISTORY:ANOTHER_PERIOD:APPLY';
export const LOAD_NEXT_PAGE = 'DETAILED_TRANSACTIONS_HISTORY:LOAD_NEXT_PAGE';
export const EXPORT_TRANSACTIONS = 'DETAILED_TRANSACTIONS_HISTORY:EXPORT_TRANSACTIONS';

export const updateSummaryData = (data) => ({
    type: UPDATE_SUMMARY_DATA,
    payload: data
});

export const updateHistoryData = (data) => ({
    type: UPDATE_HISTORY_DATA,
    payload: data
});

export const updateProperty = (property, value) => ({
    type: UPDATE_PROPERTY,
    payload: { property, value }
});

export const changePeriod = ({ period, startDate, endDate }) => ({
    type: CHANGE_PERIOD,
    payload: { period, startDate, endDate }
});

export const changeFilter = (filter) => ({
    type: CHANGE_FILTER,
    payload: filter
});

export const applyAnotherPeriod = ({ from, until }) => ({
    type: APPLY_ANOTHER_PERIOD,
    payload: { from, until }
});

export const exportTransactions = (data) => ({
    type: EXPORT_TRANSACTIONS,
    payload: data
});

export const loadNextPage = () => ({
    type: LOAD_NEXT_PAGE
});

export const fetchFail = (data) => ({
    type: FETCH_FAIL,
    payload: data
});
